// MainComp.jsx

import React, { useEffect } from 'react';
import './MainComp.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const MainComp = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <div className="mainClient-section">
      <div className="overlay"></div>
      <div className='main-title-Clientsection'>
        <h1 className="mainClient-title" data-aos="fade-down">Our Clients</h1>
      </div>
    </div>
  );
};

export default MainComp;
